export default __webpack_public_path__ + "static/media/ats.a286b870.jpg";